import { useState } from "react";
import TableBuySellVolume from "./TableBuySellVolume";
import TableBuySellDelta from "./TableBuySellDelta";

export default function SimulationCumulatedCostAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  activeChartTab = "Buy/Sell",
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  activeChartTab?: string;
}) {
  const [loading, setLoading] = useState(false);

  return (
    <div className="dash-card !border !border-[#DFEAF2] bg-white w-full !h-[400px] rounded-2xl overflow-hidden p-0">
      {activeChartTab === "Buy/Sell" && (
        <TableBuySellVolume loading={loading} />
      )}
      {activeChartTab === "Buy/Sell Delta" && (
        <TableBuySellDelta loading={loading} />
      )}
    </div>
  );
}
